import React, { useEffect, useState } from "react";
import DashboardLayout from "@/components/DashboardLayout";
import { api } from "@/lib/api";
import { formatGBP, formatDate } from "@/lib/utils-cart";
import { GatewayBadge, PaymentStatusBadge, StatusPill } from "@/components/Badges";
import { Truck, X } from "lucide-react";
import { toast } from "sonner";

export default function Fulfillment() {
  const [orders, setOrders] = useState([]);
  const [active, setActive] = useState(null);
  const [form, setForm] = useState({ tracking_number: "", carrier: "Royal Mail", status: "shipped" });

  const load = () => api.get("/orders/mine").then((r) => setOrders(r.data.filter((o) => o.payment_status === "paid" && o.shipment?.status !== "delivered")));
  useEffect(() => { load(); }, []);

  const save = async () => {
    await api.patch(`/orders/${active.id}/shipment`, form);
    toast.success("Tracking updated");
    setActive(null);
    setForm({ tracking_number: "", carrier: "Royal Mail", status: "shipped" });
    load();
  };

  return (
    <DashboardLayout title="Fulfillment Queue" subtitle="Paid orders ready to ship. Update tracking and status here.">
      <div className="v-card p-0 overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-muted/50">
            <tr className="text-left text-xs uppercase tracking-wider text-muted-foreground border-b border-border">
              <th className="p-3">Order</th>
              <th className="p-3">Buyer</th>
              <th className="p-3">Items</th>
              <th className="p-3">Status</th>
              <th className="p-3">Gateway</th>
              <th className="p-3 text-right">Total</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {orders.map((o) => (
              <tr key={o.id} className="border-b border-border last:border-0 hover:bg-muted/30">
                <td className="p-3">
                  <div className="font-mono text-xs">{o.order_number}</div>
                  <div className="text-xs text-muted-foreground">{formatDate(o.created_at)}</div>
                </td>
                <td className="p-3">{o.buyer_name}<div className="text-xs text-muted-foreground font-mono">{o.shipping_address?.city}, {o.shipping_address?.province}</div></td>
                <td className="p-3 font-mono text-xs">{o.items?.length} items</td>
                <td className="p-3"><StatusPill tone={o.shipment?.status === "shipped" ? "info" : "warning"}>{o.shipment?.status || "pending"}</StatusPill></td>
                <td className="p-3"><GatewayBadge gateway={o.gateway} /></td>
                <td className="p-3 text-right font-mono">{formatGBP(o.total)}</td>
                <td className="p-3 text-right">
                  <button onClick={() => { setActive(o); setForm({ tracking_number: o.shipment?.tracking_number || "", carrier: o.shipment?.carrier || "Royal Mail", status: o.shipment?.status === "delivered" ? "shipped" : (o.shipment?.status || "shipped") }); }} className="v-btn-outline text-xs" data-testid={`fulfill-${o.id}`}>
                    <Truck size={12} /> Update
                  </button>
                </td>
              </tr>
            ))}
            {orders.length === 0 && <tr><td colSpan={7} className="p-10 text-center text-muted-foreground">No paid orders waiting to ship.</td></tr>}
          </tbody>
        </table>
      </div>

      {active && (
        <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4" onClick={() => setActive(null)}>
          <div className="bg-card max-w-md w-full rounded-sm border border-border p-6" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between">
              <h2 className="font-display text-lg font-bold text-primary">{active.order_number}</h2>
              <button onClick={() => setActive(null)} className="v-btn-ghost"><X size={18} /></button>
            </div>
            <div className="mt-4 space-y-3">
              <input className="v-input" placeholder="Tracking number" value={form.tracking_number} onChange={(e) => setForm({...form, tracking_number: e.target.value})} data-testid="fulfill-tracking" />
              <input className="v-input" placeholder="Carrier" value={form.carrier} onChange={(e) => setForm({...form, carrier: e.target.value})} data-testid="fulfill-carrier" />
              <select className="v-input" value={form.status} onChange={(e) => setForm({...form, status: e.target.value})} data-testid="fulfill-status">
                {["pending","label_created","shipped","in_transit","delivered"].map((s) => <option key={s} value={s}>{s.replace("_", " ")}</option>)}
              </select>
              <button onClick={save} className="v-btn-primary w-full" data-testid="fulfill-save">Save shipment</button>
            </div>
          </div>
        </div>
      )}
    </DashboardLayout>
  );
}
